module.exports = __webpack_public_path__ + "img/logo-new.6ba64be3.svg";